export type TestingStatus = { activated: boolean; text: string };

export interface AssetsTesting {
  /**
   * Handle global "testing mode" by setting a cookie.
   */
  testing: {
    /**
     * Activate "debug mode" by setting a cookie.
     *
     * @return {string} Status string.
     */
    activate: () => string;
    /**
     * Deactivate "debug mode" by deleting the debug cookie.
     *
     * @return {string} Status string.
     */
    deactivate: () => string;
    /**
     * Check if debug cookie was set.
     * Returns updated statusObject
     *
     * @return {TestingStatus} Object holding status information of debug mode.
     */
    status: () => TestingStatus;
  };
}

/**
 * Check if debug cookie was set.
 * Returns updated statusObject
 *
 * @return {TestingStatus} Object holding status information of debug mode.
 */
function getStatus(): TestingStatus {
  if (document.cookie.match(/AS_testing=true/i)) {
    return { activated: true, text: "activated" };
  }
  return { activated: false, text: "deactivated" };
}

/**
 * Activate "debug mode" by setting a cookie.
 *
 * @return {String} Status string.
 */
function activate(): string {
  if (!getStatus().activated) {
    document.cookie = "AS_testing=true";
  }

  return getStatus().text;
}

/**
 * Deactivate "debug mode" by deleting the debug cookie.
 *
 * @return {String} Status string.
 */
function deactivate(): string {
  if (getStatus().activated) {
    document.cookie = `AS_testing=; expires=${new Date().toUTCString()}`;
  }

  return getStatus().text;
}

window.AS = window.AS || {};

/**
 * Handle global "testing mode" by setting a cookie.
 *
 * @return {Object} Public API of AS.testing
 */
window.AS.testing = { activate, deactivate, status: getStatus };
